"use client";

import { AppHeaderBar } from "@biom3/react";
import { useSearchParams } from "next/navigation";
import { OnboardingDotStepper } from "./OnboardingDotStepper";

export function OnboardingHeader({
  isLoggedOut,
  onMenuClick,
}: { isLoggedOut: boolean; onMenuClick: () => void }) {
  const referralCode = useSearchParams()?.get("ref")?.trim();

  return (
    <AppHeaderBar
      testId="onboarding-header"
      sx={{
        pos: "absolute",
        top: "0",
        left: "0",
        background: "#0D0D0D",
        paddingY: "0px",
        height: "auto",
        display: { default: "flex", medium: "none" },
        "& > div:first-of-type": {
          gap: "0px",
          padding: "8px",
          minHeight: "0px",
        },
      }}
    >
      <AppHeaderBar.LeftButtCon
        testId="header-smallscreen"
        size="small"
        icon="Menu"
        onClick={onMenuClick}
        sx={{
          d: { default: "flex", medium: "none" },
        }}
      />

      {isLoggedOut || referralCode ? (
        <AppHeaderBar.LeftLogo
          testId="compact-header-logo"
          logo={"PlayHorizontalLockupCompact"}
          sx={{
            d: { default: "flex", medium: "none" },
            ml: "base.spacing.x2",
          }}
        />
      ) : null}

      {!isLoggedOut && !referralCode ? (
        <AppHeaderBar.Title
          rc={<div />}
          data-testid="header-progress-bar-title"
          sx={{
            minHeight: "inherit",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <OnboardingDotStepper />
        </AppHeaderBar.Title>
      ) : null}
    </AppHeaderBar>
  );
}
